/*const mode = 'cors';
const host = 'http://web.hiphop.top/';*/

const mode = 'same-origin';
const host = 'https://m.vhiphop.com/api/';

export default {
  host,
  // host: 'https://m.vhiphop.com/api/',

  //GET请求
  get(url, data = null) {
    // return this.ajax('GET', url, null);
    return this.fetch('GET', url, data);
  },

  //POST请求
  post(url, data = null) {
    return this.fetch('POST', url, data);
  },

  // PUT全部更新
  put(url, data = null) {
    return this.fetch('PUT', url, data);
  },

  // PATCH 局部更新
  patch(url, data = null) {
    return this.fetch('PATCH', url, data);
  },

  //Delete请求
  del(url, data = null) {
    return this.fetch('DELETE', url, data);
  },

  fetch(method, url, data) {

    let init = {
      method,
      mode,
      headers: {'Content-Type': 'application/json'},
      credentials: 'include',
    };

    // 将数据拼接成表单形式的键值对
    if (data) {
      if (method === 'GET' || method === 'DELETE') {
        let params = [];
        Object.keys(data).forEach((k) => {
          params.push(`${encodeURIComponent(k)}=${encodeURIComponent(data[k])}`);
        });
        url += '?' + params.join('&');
      } else {
        init.body = JSON.stringify(data);
      }
    }

    return fetch(url.includes('http') ? url : `${host}${url}`, init).then(e => {
      switch (e.status) {
        case 200: return e.json();
        case 204: break;
        case 401: return Promise.reject({status_code: 401, message: '登录已过期, 请重新登录'});
        case 403: return e.json().then(e => Promise.reject(e));// 服务端主动抛出错误
        default: return Promise.reject({status_code: 500, message: '服务器繁忙, 请稍后再试'});
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/api/index.js